<div class="auth-container">
  <div class="row auth-main">
    <div class="col-sm-6 px-0 d-none d-sm-block">
      <div class="left-img" style="background-image: url(assets/images/pages/bg_med1.png);">
      </div>
    </div>
    <div class="col-sm-6 auth-form-section">
      <div class="form-section">
        <div class="auth-wrapper">
          <div>
            <span class="error-header p-b-45">
              403
            </span>
            <span class="error-subheader p-b-5">
              Похоже, ты заблудился
            </span>
            <span class="error-subheader2 p-b-5">
              У вас нет прав для просмотра этой страницы
            </span>
            <div class="container-auth-form-btn mt-5">
              <a href="/" class="auth-form-btn">
                Вернуться на домашнюю страницу
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
